import { gql } from '@apollo/client';

export const LOB_PRODUCT_LIST = gql`
query lobProductList {
  lobProductList {
    lob_name
    lob_code
    lob_short_name
    category
    products {
      product_name
      product_code
      product_category
      product_types {
        code
        value
      }
      linkTo
    }
  }
}
`;
export const VIEW_PROPOSAL_TW = gql`
  query viewProposalTwoWheeler($input: viewProposalInput) {
    viewProposalTW(input: $input) {
      proposalNumber
      tenure
      proposalStatus
      policyNumber
      adjustmentIRF2
      IRF2comments
      isApplicableForPayment
      isVehicleInspectionNeeded
      premium {
        idv1
        idv3
        idv2
        tenure
        netODPremium
        netTPPremium
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
        vehicleAge
        claimFreeYear
        creditScore
        NCB
      }
      customerID
      product {
        productCode
        productName
      }
      productType
      businessType
      intermediaryDetails {
        code
        location
        fieldUserCode
        fieldUserName
      }
      rtoDetails {
        rtoAuthCode
        rtoLocCode
        rtoLocDesc
      }
      vehicleDetails {
        make {
          code
          value
        }
        model {
          code
          value
        }
        variant {
          code
          value
        }
        fuelType
        seatingCapacity
        cubicCapacity
        segmentType
        gvw
        manufactureYear
        regPurchaseDate
        engineNumber
        chasisNumber
        registrationNumber
        preInspectionNumber
      }
      totalIDV
      bodyIDV
      firstYearIDV
      irf1
      isTrailerRequired 
      towedby
      trailerDetails{
        make
        model
        regnumber
        ChassisNumber
        SI
        yearofmanufacture
      }
      isPreviousPolicy
      prevInsuranceDetails {
        insurerName
        policyNumber
        expiryDate
        startDate
        coverType
        policyTenure
        insurerNameTP
        insurerAddressTP
        policyNumberTP
        expiryDateTP
        startDateTP
      }
      previousClaims {
        totalClaimCount
        claimsInYear1
        claimsInYear2
        claimsInYear3
        prevNCBSlab
        totalClaimAmount
        claimFreeYear
      }
      financerDetails {
        vehicleOwned
        financerName
        financerAddress
        financerAgreementType
        loanAccountNumber
        fileNumber
      }
      riskCovers {
        riskType
        covers {
          name
          index
          selected
          attributes {
            name
            value
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
          }
        }
      }
      creditScore {
        discountOpted
        idProofType
        idProofNumber
        creditScore
      }
      proposerPincode
      voluntaryDeductibleAmt
      NCB
      quoteNumber
      nomineeDetails {
        relationship
        name
        dob
        relationshipWithAppointee
        nameOfAppointee
      }
      leadGenerator
      proposalPaymentType
      policy {
        startDate
        endDate
        time
      }
      lob {
        lobCode
        lobName
      }
      userID
    }
  }
`;
